import { z } from 'zod';
export const RefreshStateSchema = z.object({
    revision: z.string(),
    pending: z.boolean(),
});
export const InboxCountSchema = z.object({
    count: z.number().int().nonnegative(),
});
